import { __, Alert, confirm } from 'modules/theme';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import Select from 'react-select-plus';
import {
  ModalTrigger,
  Pagination,
  Button,
  ButtonCommonTheme,
  FormControl,
  Table,
  Label,
  DataWithLoader,
  FormGroup,
  ControlLabel
} from 'modules/theme';
import {
  ModalFooter,
  FormWrapper,
  FormColumn,
  ColumnTitle,
  InfoWrapper
} from 'modules/theme';
// import { APIManager } from '../../../../theme';
import APIManager from 'modules/common/apiManager';

class ComponentAddEdit extends Component {
  constructor(props) {
    super(props);
    this.moduleName = `Holiday`;
    this.moduleUrl = `setting/holiday`;
    this.saveData = this.saveData.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);
    this.mAPI = new APIManager();
    this.setData(this.props.editData);
  }
  setData(editData = '') {
    editData = editData || {};
    this.state = {
      name: editData.name || '',
      start_date: editData.start_date || '',
      end_date: editData.end_date || '',
      group: editData.group || '',
      file: editData.file || ''
    };
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  handleSelect(selectedOption, name) {
    this.setState({ [name]: selectedOption ? selectedOption.value : null });
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      // Alert.success(`${data.message}`);
      let message = data && data.message ? data.message : "Successfully Done";
      Alert.success(message);
      this.setData();
      this.props.closeModal(true);
    } else {
      // Alert.error(`${data.message}`);
      let message = data && data.message ? data.message : "Something wrong happened";
      Alert.error(message);
    }
  }

  saveData(e) {
    e.preventDefault();
    let _this = this;
    let Name = this.state.name || "";
    Name = Name.trim();
    let tData = {
      name: Name,
      start_date: this.state.start_date,
      end_date: this.state.end_date,
      group: this.state.group,
      file: this.state.file
    };
    if (this.props.editData && this.props.editData._id) {
      this.mAPI.sendPostAPI(
        `${this.moduleUrl}/${this.props.editData._id}`,
        tData,
        data => {
          if (data) {
            _this.setData();
            _this.props.closeModal(true);
            Alert.success(`${this.moduleName} is Updated.`);
          }
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        },
        'private',
        { id: tData._id },
        'PUT'
      );
    } else {
      this.mAPI.sendPostAPI(
        `${this.moduleUrl}`,
        tData,
        data => {
          _this.setData();
          _this.props.update();
          _this.props.closeModal(true);
          Alert.success(`${this.moduleName} is Created.`);
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        }
      );
    }
  }

  render() {
    const { modalType } = this.props;
    return (
      <form onSubmit={e => this.saveData(e)}>
        <FormWrapper>
          <FormColumn>
            {this.renderFormGroup('name', {
              defaultValue: '',
              autoFocus: true,
              required: true,
              id: 'name',
              maxLength: 25,
              value: this.state.name,
              onChange: e => {
                if (e.target && e.target.value) {
                  this.setState({ name: e.target.value });
                } else {
                  this.setState({ name: "" });
                }
              }
            })}
          </FormColumn>
        </FormWrapper>
        <FormWrapper>
          <FormColumn>
            {this.renderFormGroup('start_date', {
              defaultValue: '',
              autoFocus: false,
              required: true,
              id: 'start_date',
              type: 'date',
              componentClass: 'date',
              value: this.state.start_date,
              onChange: e => {
                this.setState({ start_date: e.target.value });
              }
            })}
          </FormColumn>
          <FormColumn>
            {this.renderFormGroup('end_date', {
              defaultValue: '',
              autoFocus: false,
              required: true,
              id: 'end_date',
              type: 'date',
              componentClass: 'date',
              value: this.state.end_date,
              onChange: e => {
                this.setState({ end_date: e.target.value });
              }
            })}
          </FormColumn>
        </FormWrapper>
        <FormWrapper>
          <FormColumn>
            {this.renderFormGroup('group', {
              defaultValue: '',
              autoFocus: false,
              id: 'group',
              value: this.state.group,
              onChange: e => {
                this.setState({ group: e.target.value });
              }
            })}
            {/* {this.renderFormGroup('file', {
              defaultValue: '',
              autoFocus: true,
              required: true,
              type: 'file',
              componentClass: 'file',
              accept: 'audio/mp3,audio/wav',
              id: 'file',
              value: this.state.file,
              onChange: e => {
                this.setState({ file: e.target.value });
              }
            })} */}
          </FormColumn>
        </FormWrapper>

        <FormWrapper>
          <FormColumn>
            {this.renderFormGroup('Bulk Upload DNC', {
              defaultValue: '',
              autoFocus: false,
              componentClass: 'file',
              type: 'file',
              value: '',
              accept: 'audio/mp3,audio/wav',
              selectedFile: this.state.file,
              onChange: e => {
                if (e.target.files && e.target.files[0]) {
                  this.setState({ file: e.target.files[0] });
                } else {
                  this.setState({ file: null });
                }
              },
              id: 'file'
            })}
          </FormColumn>
        </FormWrapper>

        <ModalFooter modalType={modalType}>
          <ButtonCommonTheme
            type='greyModalBtn'
            btnStyle="cancel"
            OnClick={() => this.props.closeModal()}
            size="xl"
          >
            Cancel
          </ButtonCommonTheme>
          <ButtonCommonTheme
            type='blueModalBtn'
            btnType="submit"
            btnStyle="default"
            size="xl"
            style={{ float: 'right' }}
          >
            {this.props.editData && this.props.editData._id ? 'Update' : 'Add'}
          </ButtonCommonTheme>
        </ModalFooter>
      </form>
    );
  }
}

ComponentAddEdit.propTypes = {
  group: PropTypes.array
};

ComponentAddEdit.contextTypes = {
  __: PropTypes.func,
  closeModel: PropTypes.func.isRequired
};

export default ComponentAddEdit;



// WEBPACK FOOTER //
// src/modules/screens/settings/Config/components/ComponentAddEdit.js